import React from 'react';

interface Props {
  heading: string;
  subheading?: string | React.ReactNode;
}

const PageSubHeader: React.FC<Props> = (props) => {
  const { heading, subheading } = props;

  return (
    <div className="w-full flex flex-col gap-2">
      <div className="font-bold uppercase text-lg">{heading}</div>

      {subheading && <div>{subheading}</div>}
    </div>
  );
};

export default PageSubHeader;
